// Recovered compiled webpack factory 29001. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      ESCAPE_REGEX: function () {
        return n;
      },
      htmlEscapeAttributeString: function () {
        return s;
      },
      htmlEscapeJsonString: function () {
        return i;
      },
    }));
  let r = {
      "&": "\\u0026",
      ">": "\\u003e",
      "<": "\\u003c",
      "\u2028": "\\u2028",
      "\u2029": "\\u2029",
    },
    n = /[&><\u2028\u2029]/g,
    a = { "&": "&amp;", '"': "&quot;", "'": "&#39;", "<": "&lt;", ">": "&gt;" },
    o = /[&"'<>]/g;
  function i(e) {
    return e.replace(n, (e) => r[e]);
  }
  function s(e) {
    return e.replace(o, (e) => a[e]);
  }
}
